module.exports = __webpack_public_path__ + "assets/images/qt1.f789eb16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/return/qt1.png
// module id = 384
// module chunks = 1